<template>
<el-row class="tab-pane-top">
  <el-col :span="12">
    <div class="box-wrapper shadow-none border-none">
      <!-- FIXME 서비스 이벤트발생여부는 라벨 있음/없음 으로 표시 -->
      <span v-if="params.managetypeId === 'SVC'" class="desc-page">{{ selectedNode.label }} 이벤트 발생 여부 <strong>{{ stateLabel }}</strong></span>
      <span v-else class="desc-page">{{ selectedNode.label }} 운영상태 <strong>{{ stateLabel }}</strong></span>
    </div>
  </el-col>
  <el-col :span="12" v-show="showAvailRate" style="text-align: right">
    <div class="box-wrapper shadow-none border-none">
      <span class="desc-page">최근 24시간 가동률은 <em class="c-pointer" @click="onClickAvailRatePopup">{{ convertAvailRate }}</em> 입니다.</span>
      <span class="progress-bar-global">
        <el-progress :show-text="false" :stroke-width="11" :percentage="availRateValueNumber"></el-progress>
      </span>
    </div>
  </el-col>
  <w-avail-rate-sliding-popup ref="availRateSlidingPopup" :obj-info="selectedNode" :agent-list="agentList"></w-avail-rate-sliding-popup>
</el-row>
</template>

<script>
import { clone, max, isNil } from 'lodash';
import { isEmpty } from '@/utils/basic';
import { getApStatusName } from '@/utils/wireless-device';
import { mapGetters } from 'vuex';
import summaryApi from '@/api/performance/summary/summary-info';
import WAvailRateSlidingPopup from '../components/AvailRateSlidingPopup';

export default {
  name: 'WOperationStateInfo',
  components: {
    WAvailRateSlidingPopup,
  },
  props: {
    params: {
      type: Object,
      default() {
        return null;
      },
    },
    rscInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    eventInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    active: Boolean,
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stateData: { stateValue: null, availRateValue: 0 },
    };
  },
  computed: {
    /**
     * 운영 상태 stateValue.value(Boolean)으로 상태 판별 후 라벨 표현
     * @author jeee12
     */
    stateLabel() {
      let label;

      if (this.params.managetypeId === 'SVC') {
        if (this.eventInfo.todayEventCount > 0) {
          label = '발생';
        } else {
          label = '미발생';
        }
      } else if (!isEmpty(this.stateData.stateValue)) {
        const stateResult = this.stateData.stateValue;
        if (this.params.managetypeId === 'E2E') {
          const stateValues = [];
          stateResult.forEach((e) => {
            if (!isEmpty(e.value)) stateValues.push(Number(e.value));
          });
          label = max(stateValues) === 1 ? 'UP' : 'DOWN';
        } else if (this.params.managetypeId === 'NMS' && this.params.objtypeId === 'WIRELESSAP') {
          label = getApStatusName(stateResult[0].value);
        } else {
          label = stateResult[0].value === '1' ? 'UP' : 'DOWN';
        }
      } else {
        label = 'DOWN';
      }
      return label;
    },
    /**
     * 프로그래스바를 위해 availRateValue가 null일 경우 availRateValueNumber = 0 리턴
     * @author jeee12
     */
    availRateValueNumber() {
      return this.stateData.availRateValue > 0 ? this.stateData.availRateValue : 0;
    },
    /**
     * 가동률 표현
     * @return {[type]} [description]
     * @author jda
     */
    convertAvailRate() {
      const value = this.stateData.availRateValue;
      if (isEmpty(value)) {
        return '-';
      }
      return `${value}%`;
    },
    showAvailRate() {
      if (this.selectedNode.obj.objManagetypeId === 'NMS' && this.selectedNode.obj.objtypeId === 'WIRELESSAP') {
        return isNil(this.selectedNode.obj.parentObjId);
      }
      return this.params.managetypeId !== 'SVC';
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler() {
        this.loadOperationStateInfo();
      },
      immediate: true,
    },
    /**
     * [요약]탭 활성화시 데이터 재로드
     * @return {[type]} [description]
     * @author jda
     */
    active() {
      this.loadOperationStateInfo();
    },
  },
  methods: {
    /**
     * 운영상태 정보 load
     * @author jeee12
     */
    loadOperationStateInfo() {
      if (!this.active) {
        return;
      }
      const operationParams = clone(this.params);
      const rscInfo = clone(this.rscInfo);
      Object.assign(operationParams, { rscInfoList: [rscInfo] });
      summaryApi.getOperationStateInfo(operationParams).then((response) => {
        if (response.data.success) {
          this.stateData = response.data.data;
        }
      });
    },
    /**
     * 가동률 시간별 막대 슬라이딩 차트 팝업
     * @author Song
     */
    onClickAvailRatePopup() {
      this.$refs.availRateSlidingPopup.open();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/OperationStateInfo.vue